import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CategoryRow from './CategoryRow';
import styles from './CategoryTable.module.css';

const CategoryTable = (props) => {
  const currCode = useSelector(
    (state) => state.user.publisher?.bookCurrency?.code
  );

  const { categories } = props;
  const contentBody = categories.map((category) => (
    <CategoryRow
      /* eslint-disable react/jsx-props-no-spreading */
      {...category}
      setSelectedCategories={props.setSelectedCategories}
      clearSelection={props.clearSelection}
    />
  ));

  return (
    <table className={styles.category__table}>
      <thead className={styles.thead}>
        <tr>
          <div className={styles.grp_1}>
            <th scope="col">#</th>
            <th scope="col">Category</th>
          </div>
          <div className={styles.grp_2}>
            <th scope="col">
              Paywall Price
              <span className={styles.currency}>({currCode})</span>
            </th>
            <th scope="col">
              Low<span className={styles.currency}>({currCode})</span>
            </th>
            <th scope="col">
              Medium<span className={styles.currency}>({currCode})</span>
            </th>
            <th scope="col">
              High<span className={styles.currency}>({currCode})</span>
            </th>
          </div>
          {/* <th scope="col">Paywall/TipJar</th> */}
          {/* <th scope="col">Paywall</th>
          <th scope="col">TipJar</th> */}
        </tr>
      </thead>
      <tbody className={styles.tbody}>{contentBody}</tbody>
    </table>
  );
};

CategoryTable.propTypes = {
  categories: PropTypes.node.isRequired,
  setSelectedCategories: PropTypes.node.isRequired,
  clearSelection: PropTypes.node.isRequired,
};

export default CategoryTable;
